import Eye from '../../src/legacy/Eye';
export default Eye;
